import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import { STEP_KEYS, STEP_ICONS, STEP_NUMS, STEP_NUMS_EN } from './constants';

export default function HowItWorks() {
  const { t, i18n } = useTranslation();
  const stepNums = i18n.language === 'bn' ? STEP_NUMS : STEP_NUMS_EN;

  return (
    <section id="how-it-works" className="py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-2">{t('landing.how.title')}</h2>
          <p className="text-center text-sm text-gray-400 mb-14">{t('landing.how.subtitle')}</p>
        </Reveal>

        <div className="relative grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-6">
          <div className="hidden sm:block absolute top-7 left-[16.5%] right-[16.5%] border-t-2 border-dashed border-violet-200" />

          {STEP_KEYS.map((k, i) => {
            const Icon = STEP_ICONS[i];
            return (
              <Reveal key={k} delay={i * 100}>
                <div className="relative flex flex-col items-center text-center">
                  <div className="relative z-10 w-14 h-14 rounded-2xl bg-gradient-to-br from-violet-500 to-purple-600 shadow-lg shadow-violet-500/10 flex items-center justify-center mb-4">
                    <Icon size={22} className="text-white" />
                  </div>
                  <span className="text-xs font-bold text-violet-400 mb-1">{stepNums[i]}</span>
                  <p className="text-sm font-semibold text-gray-800">{t(`landing.how.steps.${k}.title`)}</p>
                  <p className="text-xs text-gray-400 mt-1.5 leading-relaxed max-w-[220px]">{t(`landing.how.steps.${k}.desc`)}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
